<template>
  <div>
    <b-row class="mt-3">
      <b-col>
        <b-form @submit="search" @reset="resetFilters">
          <b-card>
            <template #header>
              <div class="float-left">
                <h4>Filters</h4>
              </div>
              <div class="float-right">
                <b-button variant="outline-danger" type="reset" class="ml-3">Reset</b-button>
                <b-button variant="primary" type="submit" class="ml-3">Apply</b-button>
              </div>
            </template>

            <b-row>
              <b-col>
                <b-form-group
                  id="filters-clients"
                  label="Clients">
                  <multiselect :disabled="loading"
                               v-model="filters.clients.selected"
                               tag-placeholder=""
                               placeholder="Select clients"
                               :options="filters.clients.options"
                               label="display"
                               track-by="id"
                               :limit="10"
                               :multiple="true"
                               :taggable="false">
                  </multiselect>
                </b-form-group>
              </b-col>

              <b-col>
                <b-form-group
                  id="filters-partners"
                  label="Partners:">
                  <multiselect :disabled="loading"
                               v-model="filters.partners.selected"
                               tag-placeholder=""
                               placeholder="Select partners"
                               :options="filters.partners.options"
                               label="display"
                               track-by="id"
                               :limit="10"
                               :multiple="true"
                               :taggable="false">
                  </multiselect>
                </b-form-group>
              </b-col>
            </b-row>

            <template #footer>
              <b-table :fields="list.fields" :items="list.data" :busy="loading"
                       outlined striped small :show-empty="true" empty-text="No integrations found">

                <template #table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong class="ml-1">Loading...</strong>
                  </div>
                </template>

                <template #cell(client_name)="data">
                  {{ filters.clients.options.find(c => c.id === data.item.client_id)?.display_name }}
                </template>

                <template #cell(partners)="data">
                  <span
                    class="badge mr-2 badge-primary"
                    v-for="(value, key) in data.item.partners" :key="key">
                    {{ capitalizeFirstLetter(value) }}
                  </span>
                </template>

                <template #cell(actions)="data">
                  <b-button
                    v-if="$acl.check('onboarding.clients.integrations.edit')"
                    size="sm"
                    variant="info"
                    @click="edit(data.item.client_id)">
                    <feather type="edit-2" class="mr-1" /> Edit
                  </b-button>
                </template>
              </b-table>

              <b-row>
                <b-col class="d-flex justify-content-between">
                  <div>
                    <p>
                      Total:
                      <b-spinner v-if="loading" small></b-spinner>
                      <span v-else>{{ pagination.total }}</span>
                    </p>
                  </div>
                  <b-pagination :disabled="loading"
                                @change="changePage"
                                v-model="pagination.current"
                                :total-rows="pagination.total"
                                :per-page="filters.page_size"
                                size="md">
                  </b-pagination>
                </b-col>
              </b-row>
            </template>
          </b-card>
        </b-form>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from 'axios';
import Multiselect from 'vue-multiselect';
import Vue from 'vue';

export default {
  name: 'SamlTab',
  components: {
    Multiselect,
  },
  data() {
    return {
      loading: true,
      filters: {
        clients: {
          selected: null,
          options: [],
        },
        partners: {
          selected: null,
          options: [],
        },
        page_size: 10,
      },
      pagination: {
        current: 1,
        total: 0,
      },
      list: {
        fields: [
          { key: 'client_id', label: 'Client ID' },
          { key: 'client_name', label: 'Client Name' },
          { key: 'partners', label: 'Partners' },
          { key: 'actions', label: 'Actions' },
        ],
        data: [],
      },
    };
  },
  async beforeMount() {
    await Promise.all([
      this.loadFilters(),
      this.fetch(),
    ]);
    this.loading = false;
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    resetFilters(event) {
      event.preventDefault();
      this.filters.clients.selected = null;
      this.filters.partners.selected = null;
      this.pagination.current = 1;
      return this.fetch();
    },
    search(event) {
      event.preventDefault();
      return this.fetch();
    },
    edit(id) {
      this.$router.push(`/onboarding/clients/${id}/sso/integrations`);
    },
    changePage(page) {
      this.pagination.current = page;
      return this.fetch();
    },
    fetch() {
      this.loading = true;

      return axios.get('v1/saml/client/integrations/search', {
        params: {
          page: this.pagination.current - 1,
          limit: this.filters.page_size,
          client_ids: this.filters.clients?.selected?.map(c => c.id).join(','),
          partner_ids: this.filters.partners?.selected?.map(i => i.id).join(','),
        },
      })
        .then(response => {
          this.list.data = response.data.data;
          this.pagination.total = response.data.pagination.total;
        })
        .catch(e => {
          Vue.prototype.$noty.error('Cannot fetch list', e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async loadFilters() {
      const [ clients, partners ] = await Promise.all([
        axios.get('v1/clients').then(({ data }) => data?.payload || []),
        axios.get('v1/saml/core/partners').then(({ data }) => data || []),
      ]);

      this.filters.clients.options = clients.map(client => ({
        id: client.id,
        display_name: client.display_name,
        display: `(${client.id}) ${client.display_name}`,
      }));

      this.filters.partners.options = partners.map(partner => ({
        id: partner,
        display: this.capitalizeFirstLetter(partner),
      }));
    },
  },
};
</script>
